



















































































































































































































































































































































































import _ from "lodash";
import Vue, { PropType } from "vue";

// Vuex
import { RootState } from "@/store";
import { mapGetters, mapState } from "vuex";

// Vue components
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import PredictedStatusInstallationChip from "@/views/App/Components/chips/PredictedStatusInstallationChip.vue";
import DataFlowDeviceDetailsCard from "@/views/App/Components/DataFlowDeviceDetailsCard.vue";
import SmartLockDetailCard from "@/views/App/OneTimeCode/SmartLock/SmartLockDetailCard.vue";
import InstallationLogAnalysis from "@/views/App/PredictiveMaintenance/LogAnalysis/InstallationLogAnalysis.vue";
import InstallationPredictedStatusDetails from "@/views/App/PredictiveMaintenance/PredictiveMaintenance/InstallationPredictedStatusDetails.vue";
import RemoteLinkDetails from "@/views/App/RemoteLink/RemoteLink/RemoteLinkDetails.vue";
import SecurityManagementCard from "@/views/App/SecurityAndConfiguration/SecurityManagement/SecurityManagementCard.vue";
import StocksConfigCard from "@/views/App/SecurityAndConfiguration/StocksConfiguration/StocksConfigCard.vue";
import InstallationStatusDetails from "@/views/App/ServiceAndUpdates/DeviceStatus/InstallationStatusDetails/InstallationStatusDetails.vue";
import BulkUpdatesWizard from "@/views/App/ServiceAndUpdates/UpdatesManagement/BulkUpdatesWizard/index.vue";
import InstallationNotification from "@/views/App/ServiceAndUpdates/UpdatesManagement/DetailsSection/InstallationNotification.vue";
import StatusAndUpdatesSection from "@/views/App/Tools/InstallationDetails/StatusAndUpdatesSection.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetInstallationBranchHistoryCommand } from "@/model/communication/branch/GetInstallationBranchHistoryCommand";
import { FetchInstallationsSmartLockStatusCommand, FetchInstallationsSmartLockStatusReqData } from "@/model/communication/oneTimeCode/FetchInstallationsSmartLockStatusCommand";
import { FetchInstallationsSmartLockStatusResData } from "@/model/communication/oneTimeCode/FetchInstallationsSmartLockStatusResData";
import { FetchInstallationsPredictedStatusCommand, GetDevicesPredictedStatusReqData } from "@/model/communication/predictiveMaintenance/FetchInstallationsPredictedStatusCommand";
import { FetchInstallationsPredictedStatusResponse } from "@/model/communication/predictiveMaintenance/FetchInstallationsPredictedStatusResponse";
import { FetchInstallationsRemoteLinkStatusCommand, FetchInstallationsRemoteLinkStatusReqData } from "@/model/communication/remoteLink/FetchInstallationsRemoteLinkStatusCommand";
import { FetchInstallationsRemoteLinkStatusResData } from "@/model/communication/remoteLink/FetchInstallationsRemoteLinkStatusResData";
import {
    FetchInstallationsRollsConfigurationCommand,
    FetchInstallationsRollsConfigurationReqData,
} from "@/model/communication/security/FetchInstallationsRollsConfigurationCommand";
import { FetchInstallationsRollsConfigurationResData } from "@/model/communication/security/FetchInstallationsRollsConfigurationResData";
import {
    FetchInstallationsSecurityConfigurationCommand,
    FetchInstallationsSecurityConfigurationReqData,
} from "@/model/communication/security/FetchInstallationsSecurityConfigurationCommand";
import { FetchInstallationsSecurityConfigurationResData } from "@/model/communication/security/FetchInstallationsSecurityConfigurationResData";
import { FetchInstallationsStatusCommand, GetDevicesStatusReqData } from "@/model/communication/status/FetchInstallationsStatusCommand";
import { FetchInstallationsStatusResponse } from "@/model/communication/status/FetchInstallationsStatusResponse";
import {
    FetchInstallationsUpdatesStatusRequestData,
    GetServerFetchInstallationsUpdatesStatusReqData,
} from "@/model/communication/updatesStatus/FetchInstallationsUpdatesStatusRequestData";
import { FetchInstallationUpdatesStatusCommand } from "@/model/communication/updatesStatus/FetchInstallationUpdatesStatusCommand";
import { FetchInstallationUpdatesStatusResponse } from "@/model/communication/updatesStatus/FetchInstallationUpdatesStatusResponse";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { ClientUser } from "@/model/data/authentication/ClientUser";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { InstallationSmartLockStatus } from "@/model/data/oneTimeCode/InstallationSmartLockStatus";
import { InstallationPredictedStatus } from "@/model/data/predictiveMaintenance/InstallationPredictedStatus";
import { InstallationRemoteLinkStatus } from "@/model/data/remoteLink/InstallationRemoteLinkStatus";
import { InstallationSecurityConfiguration } from "@/model/data/security/InstallationSecurityConfiguration";
import { InstallationStocksConfiguration } from "@/model/data/security/InstallationStocksConfiguration";
import { InstallationStatus } from "@/model/data/status/InstallationStatus";
import { InstallationUpdate } from "@/model/data/updates/InstallationUpdate";
import { MODULE_COLORS } from "@/utility/Constants";

export default Vue.extend({
    components: {
        PredictedStatusInstallationChip,
        DeviceModelChip,
        InstallationPredictedStatusDetails,
        StatusAndUpdatesSection,
        InstallationLogAnalysis,
        BulkUpdatesWizard,
        InstallationStatusDetails,
        InstallationNotification,
        SecurityManagementCard,
        StocksConfigCard,
        RemoteLinkDetails,
        SmartLockDetailCard,
        DataFlowDeviceDetailsCard,
    },
    data() {
        return {
            installationStatus: null,
            installationUpdate: null,
            installationPredictedStatus: null,
            installationSecurityConfiguration: null,
            installationStocksConfiguration: null,
            installationRemoteLinkStatus: null,
            installationSmartLockStatus: null,
            installationBranchMovingList: [],
            selectedTab: this.tab,
            loading: 0,
            windowHeight: window.innerHeight,
            blue: MODULE_COLORS.SERVICE_AND_UPDATES,
            purple: MODULE_COLORS.PREDICTIVE_MAINTENANCE,
            darkblue: MODULE_COLORS.REMOTE_LINK,
            mintgreen: MODULE_COLORS.ONE_TIME_CODE,
            turquoise: MODULE_COLORS.DATAFLOW,
            forceCheckRequestedDevices: [],
            reloadNotifications: 0,
            smartLockPanels: [],
        };
    },
    props: {
        tab: { required: true, type: String },
        installation: {
            required: true,
            type: Object as PropType<
                | InstallationPredictedStatus
                | InstallationStatus
                | InstallationUpdate
                | InstallationSecurityConfiguration
                | InstallationStocksConfiguration
                | InstallationRemoteLinkStatus
                | InstallationSmartLockStatus
            >,
        },
        showDialog: { required: true, type: Boolean },
    },
    watch: {
        installation() {
            this.reload();
        },
        showDialog: {
            handler(val) {
                document.querySelector("html").style.overflowY = val ? "hidden" : "auto";
            },
            immediate: true,
        },
    },
    computed: {
        ...mapState({
            authUser: (state: RootState) => state.authMod.currentUser,
        }),

        ...mapGetters(["authUserHasPrivilege"]),

        localShowDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
            },
        },

        installationIsUpToDate() {
            if (this.installationUpdate == null || this.installationUpdate == undefined) return true;
            return this.installationUpdate.isUpToDate();
        },

        caosBackendAddress() {
            if (this.installationUpdate) return (this.installationUpdate as InstallationUpdate).getBackendAddress();
            return [];
        },

        updatesManagementEnabled() {
            return (
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.ServiceAndUpdatesManagement) != LicenseModuleEnum.None &&
                this.authUserHasPrivilege(ClientPrivileges.UpdatesManagement)
            );
        },

        statusManagementEnabled() {
            return (
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.ServiceAndUpdatesManagement) != LicenseModuleEnum.None &&
                this.authUserHasPrivilege(ClientPrivileges.StatusManagement)
            );
        },

        remoteLinkEnabled() {
            if (this.installation != null && this.installation.isThirdParty) return false;
            return (
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.RemoteLink) != LicenseModuleEnum.None &&
                (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkHttp) ||
                    this.authUserHasPrivilege(ClientPrivileges.RemoteLinkCaosDb) ||
                    this.authUserHasPrivilege(ClientPrivileges.RemoteLinkSsh) ||
                    this.authUserHasPrivilege(ClientPrivileges.RemoteLinkUltraVnc) ||
                    this.authUserHasPrivilege(ClientPrivileges.RemoteLinkCService) ||
                    this.authUserHasPrivilege(ClientPrivileges.RemoteLinkCustom))
            );
        },

        smartLockEnabled() {
            if (this.installation != null && this.installation.isThirdParty) return false;
            return (
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.OneTimeCode) != LicenseModuleEnum.None &&
                (this.authUserHasPrivilege(ClientPrivileges.SmartLockManagement) || this.authUserHasPrivilege(ClientPrivileges.SmartLockActivation))
            );
        },

        logAnalysisEnabled() {
            if (this.installation != null && this.installation.isThirdParty) return false;
            return (
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.PredictiveMaintenance) != LicenseModuleEnum.None &&
                this.authUserHasPrivilege(ClientPrivileges.LogAnalysis)
            );
        },

        predictiveMaintenanceEnabled() {
            if (this.installation != null && this.installation.isThirdParty) return false;
            return (
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.PredictiveMaintenance) != LicenseModuleEnum.None &&
                this.authUserHasPrivilege(ClientPrivileges.ReadPredictiveMaintenance)
            );
        },

        securityManagementEnabled() {
            if (this.installation != null && this.installation.isThirdParty) return false;
            let banknoteMachine = this.installation.machines.filter((m) => m.supportedCashType == CashTypeEnum.Banknote);
            if (!banknoteMachine || banknoteMachine.length < 1) return false;
            let machineModel = banknoteMachine[0].model;
            if (machineModel == null || machineModel == undefined) return false;
            return (
                machineModel.startsWith("AST") &&
                !machineModel.includes("9000") &&
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.SecurityManagement) != LicenseModuleEnum.None &&
                this.authUserHasPrivilege(ClientPrivileges.SecurityManagement)
            );
        },

        stocksConfigEnabled() {
            if (this.installation != null && this.installation.isThirdParty) return false;
            return (
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.SecurityManagement) != LicenseModuleEnum.None &&
                this.authUserHasPrivilege(ClientPrivileges.RollsConfigurationManagement)
            );
        },

        deviceDetailsEnabled() {
            return (
                (this.installation.licenseData.enabledModules & LicenseModuleEnum.DataFlow) != LicenseModuleEnum.None &&
                this.authUserHasPrivilege(ClientPrivileges.DataFlowDeviceDetailsManagement)
            );
        },

        barColor() {
            let color = "";
            switch (this.selectedTab) {
                case "statusTab":
                    color = MODULE_COLORS.SERVICE_AND_UPDATES;
                    break;
                case "updatesTab":
                    color = MODULE_COLORS.SERVICE_AND_UPDATES;
                    break;
                case "remoteLinkTab":
                    color = MODULE_COLORS.REMOTE_LINK;
                    break;
                case "smartLockTab":
                    color = MODULE_COLORS.ONE_TIME_CODE;
                    break;
                case "logAnalysisTab":
                    color = MODULE_COLORS.PREDICTIVE_MAINTENANCE;
                    break;
                case "predictiveMaintenanceTab":
                    color = MODULE_COLORS.PREDICTIVE_MAINTENANCE;
                    break;
                case "stocksConfigTab":
                case "securityManagementTab":
                    color = "#fea310";
                    break;
                case "deviceDetailTab":
                    color = MODULE_COLORS.DATAFLOW;
                    break;
                default:
                    color = MODULE_COLORS.SERVICE_AND_UPDATES;
                    break;
            }
            return color;
        },

        isOperationsNotAvailable() {
            if (this.installation != null && this.installation.isThirdParty) return true;

            // se non ho nessuno dei seguenti privilegi allora disabilito il button delle operazioni
            if ((this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.UpdatesManagement) == ClientPrivileges.UpdatesManagement) return false;
            if ((this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.PackagesManagement) == ClientPrivileges.PackagesManagement) return false;
            if ((this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.DevicesManagement) == ClientPrivileges.DevicesManagement) return false;
            if ((this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.DownloadLogs) == ClientPrivileges.DownloadLogs) return false;
            return true;
        },
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            this.loading = 0;
            this.reloadNotifications += 1;
            let sendStatusRequest = false;
            let sendUpdatesRequest = false;
            let sendPredictedStatusRequest = false;
            let sendSecurityConfigurationRequest = false;
            let sendStockConfigurationRequest = false;
            let sendRemoteLinkRequest = false;
            let sendSmartLockRequest = false;
            this.installationStocksConfiguration = null;
            this.smartLockPanels = [0, 1, 2, 3, 4];
            switch (this.tab) {
                case "statusTab":
                    sendUpdatesRequest = true;
                    sendPredictedStatusRequest = true;
                    sendSecurityConfigurationRequest = true;
                    sendStockConfigurationRequest = true;
                    sendRemoteLinkRequest = true;
                    sendSmartLockRequest = true;
                    this.installationStatus = this.installation;
                    break;
                case "updatesTab":
                    sendStatusRequest = true;
                    sendPredictedStatusRequest = true;
                    sendSecurityConfigurationRequest = true;
                    sendStockConfigurationRequest = true;
                    sendRemoteLinkRequest = true;
                    sendSmartLockRequest = true;
                    this.installationUpdate = this.installation;
                    break;
                case "remoteLinkTab":
                    sendStatusRequest = true;
                    sendUpdatesRequest = true;
                    sendPredictedStatusRequest = true;
                    sendSecurityConfigurationRequest = true;
                    sendStockConfigurationRequest = true;
                    sendSmartLockRequest = true;
                    this.installationRemoteLinkStatus = this.installation;
                    break;
                case "smartLockTab":
                    sendStatusRequest = true;
                    sendUpdatesRequest = true;
                    sendPredictedStatusRequest = true;
                    sendSecurityConfigurationRequest = true;
                    sendStockConfigurationRequest = true;
                    sendRemoteLinkRequest = true;
                    this.installationSmartLockStatus = this.installation;
                    break;
                case "logAnalysisTab":
                    sendUpdatesRequest = true;
                    sendStatusRequest = true;
                    sendPredictedStatusRequest = true;
                    sendSecurityConfigurationRequest = true;
                    sendStockConfigurationRequest = true;
                    sendRemoteLinkRequest = true;
                    sendSmartLockRequest = true;
                    break;
                case "predictiveMaintenanceTab":
                    sendUpdatesRequest = true;
                    sendStatusRequest = true;
                    sendSecurityConfigurationRequest = true;
                    sendStockConfigurationRequest = true;
                    sendRemoteLinkRequest = true;
                    sendSmartLockRequest = true;
                    this.installationPredictedStatus = this.installation;
                    break;
                case "securityManagementTab":
                    sendUpdatesRequest = true;
                    sendStatusRequest = true;
                    sendPredictedStatusRequest = true;
                    sendStockConfigurationRequest = true;
                    sendRemoteLinkRequest = true;
                    sendSmartLockRequest = true;
                    this.installationSecurityConfiguration = this.installation;
                    break;
                case "stocksConfigTab":
                    sendUpdatesRequest = true;
                    sendStatusRequest = true;
                    sendPredictedStatusRequest = true;
                    sendSecurityConfigurationRequest = true;
                    sendRemoteLinkRequest = true;
                    sendSmartLockRequest = true;
                    this.installationStocksConfiguration = this.installation;
                    break;
            }
            if (this.updatesManagementEnabled && sendUpdatesRequest) this.getInstallationUpdate();
            else this.loading += 1;
            if (this.statusManagementEnabled && sendStatusRequest) this.getInstallationStatus();
            else this.loading += 1;
            if (this.predictiveMaintenanceEnabled && sendPredictedStatusRequest) this.getInstallationPredictedStatus();
            else this.loading += 1;
            if (this.securityManagementEnabled && sendSecurityConfigurationRequest) this.getInstallationSecurityConfiguration();
            else this.loading += 1;
            if (this.stocksConfigEnabled && sendStockConfigurationRequest) this.getInstallationStocksConfiguration();
            else this.loading += 1;
            if (this.remoteLinkEnabled && sendRemoteLinkRequest) this.getInstallationRemoteLinkStatus();
            else this.loading += 1;
            if (this.smartLockEnabled && sendSmartLockRequest) this.getInstallationSmartLockStatus();
            else this.loading += 1;
            this.getInstallationBranchMovingList();
        },

        reloadSelectedTab() {
            this.loading = 0;

            if (this.selectedTab == "statusTab" && this.statusManagementEnabled) this.getInstallationStatus();
            else this.loading += 1;
            if (this.selectedTab == "updatesTab" && this.updatesManagementEnabled) {
                this.getInstallationUpdate();
                this.reloadNotifications += 1;
            } else this.loading += 1;
            if (this.selectedTab == "securityManagementTab" && this.securityManagementEnabled) this.getInstallationSecurityConfiguration();
            else this.loading += 1;
            if (this.selectedTab == "stocksConfigTab" && this.stocksConfigEnabled) this.getInstallationStocksConfiguration();
            else this.loading += 1;
            if (this.selectedTab == "remoteLinkTab" && this.remoteLinkEnabled) this.getInstallationRemoteLinkStatus();
            else this.loading += 1;
            if (this.selectedTab == "smartLockTab" && this.smartLockEnabled) this.getInstallationSmartLockStatus();
            else this.loading += 1;
            if (this.selectedTab == "deviceDetailTab" && this.deviceDetailsEnabled) {
                window.dispatchEvent(
                    new CustomEvent("reload-dataflow-card", {
                        detail: {
                            installationName: this.installation.name,
                        },
                    })
                );
            }
            this.loading += 1; // al posto di this.getInstallationPredictedStatus();
            this.loading += 1; // al posto di this.getInstallationBranchMovingList();
            this.$emit("reload-table");
        },

        closeDialog() {
            this.$emit("close-dialog");
            this.selectedTab = this.tab;
        },
        async getInstallationStatus() {
            try {
                let req: GetDevicesStatusReqData = new GetDevicesStatusReqData();
                req.installationNames = [];
                req.installationNames.push(this.installation.name);
                let response: FetchInstallationsStatusResponse = await new FetchInstallationsStatusCommand(req).execute();
                this.loading += 1;
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installationStatus = response.installationsList[0];
                }
            } catch (e) {
                console.error("Something went wrong sending getInstallationStatus request ", e);
            }
        },

        async getInstallationUpdate() {
            try {
                let req: FetchInstallationsUpdatesStatusRequestData = new FetchInstallationsUpdatesStatusRequestData();
                req.installationNames = [];
                req.installationNames.push(this.installation.name);
                let reqToServer = GetServerFetchInstallationsUpdatesStatusReqData(req);
                let response: FetchInstallationUpdatesStatusResponse = await new FetchInstallationUpdatesStatusCommand(reqToServer).execute();
                this.loading += 1;
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installationUpdate = response.installationsList[0];
                }
            } catch (e) {
                console.error("Something went wrong sending getInstallationUpdate request ", e);
            }
        },

        async getInstallationPredictedStatus() {
            try {
                let request = new GetDevicesPredictedStatusReqData();
                request.installationNames = [this.installation.name];
                let response: FetchInstallationsPredictedStatusResponse = await new FetchInstallationsPredictedStatusCommand(request).execute();
                this.loading += 1;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.installationsList && response.installationsList.length == 1) {
                    this.installationPredictedStatus = response.installationsList[0];
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsPredictedStatusCommand request ", e);
            }
        },

        async getInstallationSecurityConfiguration() {
            try {
                let request = new FetchInstallationsSecurityConfigurationReqData();
                request.installationNames = [];
                request.installationNames.push(this.installation.name);
                let response: FetchInstallationsSecurityConfigurationResData = await new FetchInstallationsSecurityConfigurationCommand(request).execute();
                this.loading += 1;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.installationsList && response.installationsList.length == 1) {
                    this.installationSecurityConfiguration = response.installationsList[0];
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsSecurityConfiguration request ", e);
            }
        },

        async getInstallationStocksConfiguration() {
            try {
                let request = new FetchInstallationsRollsConfigurationReqData();
                request.installationNames = [];
                request.installationNames.push(this.installation.name);
                let response: FetchInstallationsRollsConfigurationResData = await new FetchInstallationsRollsConfigurationCommand(request).execute();
                this.loading += 1;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.installationsList && response.installationsList.length == 1) {
                    this.installationStocksConfiguration = response.installationsList[0];
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsRollsConfiguration request ", e);
            }
        },

        async getInstallationRemoteLinkStatus() {
            try {
                let request = new FetchInstallationsRemoteLinkStatusReqData();
                request.installationNames = [];
                request.installationNames.push(this.installation.name);
                let response: FetchInstallationsRemoteLinkStatusResData = await new FetchInstallationsRemoteLinkStatusCommand(request).execute();
                this.loading += 1;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.installationsList && response.installationsList.length == 1) {
                    this.installationRemoteLinkStatus = response.installationsList[0];
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsRemoteLinkStatus request ", e);
            }
        },

        async getInstallationSmartLockStatus() {
            try {
                let request = new FetchInstallationsSmartLockStatusReqData();
                request.installationNames = [];
                request.installationNames.push(this.installation.name);
                let response: FetchInstallationsSmartLockStatusResData = await new FetchInstallationsSmartLockStatusCommand(request).execute();
                this.loading += 1;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.installationsList && response.installationsList.length == 1) {
                    this.installationSmartLockStatus = response.installationsList[0];
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsSmartLockStatus request ", e);
            }
        },

        async getInstallationBranchMovingList() {
            try {
                this.installationBranchMovingList = [];
                let res = await new GetInstallationBranchHistoryCommand(this.installation.name).execute();
                this.loading += 1;
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installationBranchMovingList = _.orderBy(res.installationBranchMovingList, ["movingDateTime"], ["desc"]);
                } else console.error("Error executing getInstallationBranchMovingList");
            } catch (e) {
                console.error("Something went wrong sending getInstallationBranchMovingList request ", e);
            }
        },
    },
    beforeDestroy() {
        document.querySelector("html").style.overflowY = "auto";
    },
});
